module.exports = ".btn-track {\r\n    background: #d8d8d9;\r\n    border: solid 1px #989897;\r\n    border-radius: 0;\r\n    padding: 4px 20px;\r\n    font-size: 16px;\r\n    margin-right: 10px;\r\n}\r\n.imgsize{max-height:200px;\r\nmargin-right: 10px;\r\n}\r\n.btn-access-order {\r\n    background: #d8d8d9;\r\n    border: solid 1px #989897;\r\n    border-radius: 0;\r\n    padding: 4px 4px;\r\n    font-size: 13px;\r\n    margin-right: 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/order-detail/order-detail.component.css
// module id = ./src/app/shoppingcart/order-detail/order-detail.component.css
// module chunks = main